import { useCallback, useState } from 'react';
import fleetApi from '../../services/api.service';

/**
 * Suppression de BL du puits : ils sont archivés côté API (rien n'est
 * effacé) et la suppression est tracée
 */
const useArchiveDeliveryDetails = () => {
  const [isArchiving, setIsArchiving] = useState(false);

  const archiveDeliveryDetails = useCallback(async (deliveryDetailIds) => {
    setIsArchiving(true);
    try {
      const response = await fleetApi.post(
        '/tours-planning/delivery-details/archive',
        { delivery_detail_ids: deliveryDetailIds }
      );
      return response.data?.data || { archivedCount: 0 };
    } catch (err) {
      throw new Error(
        err?.response?.data?.message ||
          err.message ||
          'Impossible de supprimer les BL'
      );
    } finally {
      setIsArchiving(false);
    }
  }, []);

  return { archiveDeliveryDetails, isArchiving };
};

export default useArchiveDeliveryDetails;
